<script setup>
import { onMounted, inject } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import NewsBanner from "./Partials/NewsBanner.vue";
import LatestProjects from "./Partials/LatestProjects.vue";
import Videos from "./Partials/Videos.vue";
import LatestProfils from "./Partials/LatestProfils.vue";
import LatestSingleModeGenerations from "./Partials/LatestSingleModeGenerations.vue";

const { t: __ } = useI18n();
const route = useRoute();
const $showPricingPlans = inject("$showPricingPlans");

onMounted(() => {
    if (route.query?.trial === "ended") {
        $showPricingPlans();
    }
});
</script>

<template>
    <div class="px-4 py-16 space-y-16 lg:px-8 sm:px-6">
        <NewsBanner />

        <LatestSingleModeGenerations />
        <LatestProjects />
        <LatestProfils />

        <Videos />
    </div>
</template>
